export default function isMobile() {
	const { userAgent } = navigator;
	const isAppleTouchDevice =
		/(iphone|ipad|ipod)/i.test(userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

	if (
		userAgent.match(/Android/i) ||
		userAgent.match(/webOS/i) ||
		isAppleTouchDevice ||
		userAgent.match(/BlackBerry/i) ||
		userAgent.match(/Windows Phone/i)
	) {
		return true;
	}
	return false;
}
